import React from 'react';

const PRAYER_ACCENT = { shacharit: '#1e3a5f', mincha: '#92400e', maariv: '#312e81' };

const formatCountdown = (secs) => {
  if (secs < 0) return 'עכשיו';
  if (secs < 60) return `עוד ${secs} שנ׳`;
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m < 60) return `עוד ${m}:${String(s).padStart(2, '0')}`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return rm === 0 ? `עוד ${h} שע׳` : `עוד ${h}ש׳ ${rm}ד׳`;
};

const StatusBox = ({ msg, isError }) => (
  <div style={{
    width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    direction: 'rtl', fontSize: '1rem', color: isError ? '#c0392b' : '#94a3b8',
  }}>
    {msg}
  </div>
);

/**
 * Spotlight — רקע צבעוני מלא (צבע האקצנט) עם טקסט לבן.
 * עיצוב דרמטי לתצוגה ציבורית בולטת.
 */
const Spotlight = ({ nextMinyan, secondsLeft, upcomingPrayers, allPrayerTimes, title, showTitle, bgColor, loading, error }) => {
  if (loading) return <StatusBox msg="טוען..." />;
  if (error)   return <StatusBox msg={error} isError />;
  if (!nextMinyan) return <StatusBox msg="אין מנינים שנותרו להיום" />;

  const accent   = nextMinyan.color || PRAYER_ACCENT[nextMinyan.prayer] || '#1e3a5f';
  const panelBg  = bgColor || accent;
  const isDark   = true; // the panel always has a strong background
  const textMain = '#ffffff';
  const textSub  = 'rgba(255,255,255,0.72)';
  const countdown = formatCountdown(secondsLeft);

  return (
    <div style={{
      width: '100%', height: '100%', display: 'flex', flexDirection: 'column',
      direction: 'rtl', fontFamily: 'inherit', boxSizing: 'border-box',
    }}>
      {showTitle && (
        <div style={{
          padding: '0.6rem 1.25rem', flexShrink: 0,
          backgroundColor: 'rgba(0,0,0,0.25)',
          display: 'flex', alignItems: 'center',
        }}>
          <span style={{ fontWeight: 700, fontSize: '0.85rem', color: 'rgba(255,255,255,0.85)', letterSpacing: '0.02em' }}>
            {title}
          </span>
        </div>
      )}

      {/* Colored panel — fills the rest */}
      <div style={{
        flex: 1,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        backgroundColor: panelBg,
        padding: '1.5rem 1.25rem',
        gap: '0',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Subtle radial glow */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'radial-gradient(ellipse at 50% 40%, rgba(255,255,255,0.12) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        {/* Prayer name */}
        <div style={{
          fontSize: 'clamp(1.5rem, 5vw, 2.5rem)', fontWeight: 900,
          color: textMain, letterSpacing: '0.04em',
          textShadow: '0 1px 8px rgba(0,0,0,0.25)',
          zIndex: 1,
        }}>
          {nextMinyan.label}
        </div>

        {/* Decorative separator */}
        <div style={{
          width: 40, height: 2,
          backgroundColor: 'rgba(255,255,255,0.4)',
          borderRadius: 1, margin: '0.6rem 0',
          zIndex: 1,
        }} />

        {/* Time */}
        <div style={{
          fontSize: 'clamp(3.5rem, 12vw, 6rem)', fontWeight: 900, lineHeight: 1,
          color: textMain, fontVariantNumeric: 'tabular-nums',
          direction: 'ltr', letterSpacing: '-0.04em',
          textShadow: '0 2px 16px rgba(0,0,0,0.3)',
          zIndex: 1,
        }}>
          {nextMinyan.time}
        </div>

        {/* Countdown */}
        <div style={{
          marginTop: '1rem',
          fontSize: 'clamp(0.85rem, 2.5vw, 1.05rem)', fontWeight: 600,
          color: textSub, letterSpacing: '0.01em',
          zIndex: 1,
        }}>
          {countdown}
        </div>
      </div>
    </div>
  );
};

export default Spotlight;
